


<template>
  <div class="protocol modify-protocol">
    <navigation>天美贷用户信息变更申请书</navigation>
    <section class="content">
      <p class="text">本人 <b class="underline">  {{ content.userName }}</b> 身份证号码为<b class="underline"> {{ content.idNo }}</b> 注册手机号码为<b class="underline"> {{ content.oldMobile }}</b> ，使用天美贷用户端进行操作时，</p>

      <template v-if="content.mobileChangeInfo">
        <p class="text">因<b class="underline"> {{   mobileChangeReasonF(content.mobileChangeInfo.mobileChangeReason ,mobileChangeReason) }} </b> 需修改<b class="underline"> 手机号 </b> ，现要求变更以下信息：</p>
        <table class="ui-table">
          <tr><th>修改信息项</th><th>新手机号码</th></tr>
          <tr><td>手机号码</td><td>{{ content.mobileChangeInfo.mobile }}</td></tr>
        </table>

      </template>

      <template v-if="content.contactsChangeInfo && content.contactsChangeInfo.length">
        <p class="text">因<b class="underline"> {{  contactsChangeReasonF(content.contactsChangeInfo[0].contactsChangeReason,contactsChangeReason)}}</b>  需修改 <b class="underline">联系人信息</b>，现要求变更以下信息：</p>

        <table class="ui-table">
          <tr><th>修改信息项</th>  <th>关系</th><th>姓名</th><th>手机号</th></tr>
          <tr v-for="(item,index) in content.contactsChangeInfo" :key="item.mobile">
            <td>联系人{{ index-(-1) }}</td>
            <td>{{ relationF(item.relation)}}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.mobile }}</td>
          </tr>
        </table>
      </template>
      <p class="text">本人确认以上信息真实准确，后续产生的一切风险，本人愿意承担相应责任。</p>
      <p style="text-align: right;">{{ content.applyDate | date('YYYY年MM月DD日') }}</p>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'modifyProtocol',
  data () {
    return {
      content: '',
      mobileChangeReason: [],
      contactsChangeReason: []
    }
  },
 
  async created () {
    await Promise.all([this.fetchDictionaryX(), this.getReason()])
    this.getInfo()
    this.$bus.$emit('ready')
  },
  computed: {
    ...mapState({
      dictionary: (state) => state.dictionary || {}
    })
  },
  methods: {
    ...mapActions('modify', ['fillContent', 'userChangeReason']),
    ...mapActions(['fetchDictionaryX']),
    relationF (val) {
      if (!val) return ''
      return this.dictionary.relationship1.concat(this.dictionary.relationship2).find(item => item.key === val)?.description
    },
    mobileChangeReasonF (val) {
      if (!val) return ''
      if (val === 'OTHER') {
        return this.content.mobileChangeInfo?.otherReason
      } else {
        return this.mobileChangeReason.find(item => item.code === val)?.desc
      }
    },
    contactsChangeReasonF (val) {
      if (!val) return ''
      if (val === 'OTHER') {
        return this.content.contactsChangeInfo[0]?.otherReason
      } else {
        return this.contactsChangeReason.find(item => item.code === val)?.desc
      }
    },    
    async getInfo () {
      const { success, data } = await this.fillContent()
      if (success) {
        this.content = data || {}
      }
    },
    async getReason () {
      const { success, data } = await this.userChangeReason()

      if (success) {
        this.mobileChangeReason = data.mobileChangeReason || []
        this.contactsChangeReason = data.contactsChangeReason || []
      }

      // TODO:
      this.mobileChangeReason = [
        { code: 'NOT_USE', desc: '原手机号不再使用' },
        { code: 'LOSE', desc: '手机丢失' },
        { code: 'C', desc: '手机丢失C' },
        { code: 'OTHER', desc: '其他' }
      ]

      this.contactsChangeReason = [
        { code: 'EXPIRE', desc: '原联系人号码失效' },
        { code: 'ERROR', desc: '联系人信息错误' },
        { code: 'RELATION_CHANGE', desc: '联系人关系变更' },
        { code: 'OTHER', desc: '其他' }
      ]
    }
  }
}

</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

    .modify-protocol {
        background-color: white;
        .ui-table {
          width: 100%;
          border-left:1px solid #ccc;
          border-top:1px solid #ccc;
          border-spacing: 0;
          border-collapse: collapse;
          th,td {
            border-right:1px solid #ccc;
            border-bottom:1px solid #ccc;
            padding: 10px;
            text-align: center;
          }
        }
        .content {
            padding: 0 48px;
            .title {
                font-weight: bolder;
                color: #333333;
                font-size: 28px;
                line-height: 44px;
                margin-top: 10px;
            }
            .text {
                color: #333333;
                font-size: 28px;
                line-height: 44px;
                margin: 20px 0;
            }
            .text:last-child {
                margin-bottom: 10px;
            }
            .underline {
                font-weight: bold;
                text-decoration: underline;
            }
            .underline:last-child {
                margin-bottom: 10px;
            }
        }
    }
</style>


